import { ReactElement, useContext } from 'react';
import { DefaultLayout } from '@/layouts/index';
import { useClient } from '@/hooks';
import { StudentContext } from '@/contexts';

function Approval(): ReactElement {
  const client = useClient();
  const { state } = useContext(StudentContext);

  return (
    <DefaultLayout
      step="4 de 4"
      title="Sua análise de crédito foi aprovada!"
      cardSize="normal-card"
      progressPercentage={100}
      limitDate={
        client.processDateInfo?.limitDateFinancingRequest ||
        state.processDateInfo?.limitDateFinancingRequest
      }
    >
      <section className="large-container">
        <div className="large-container__content">
          <div className="large-container__image">
            <span>
              <img src="/assets/images/approval.svg" alt="Aprovador" />
            </span>
          </div>
          <div className="large-container__text">
            <p>
              Você e a(s) sua(s) pessoa(s) avalista(s) vão receber um e-mail da
              Docusign (plataforma de assinatura digital) para assinar o{' '}
              <b>
                documento para contratação do financiamento e de Prestação de
                Serviços Educacionais.
              </b>
            </p>
            <p>
              O prazo para assinatura do contrato se encerra no último dia da
              etapa de matrícula.
            </p>
            <p>
              Verifique sua caixa de entrada. Se em até 7 dias corridos não
              receber, entre em contato com{' '}
              <span className="large-container__link"> msc@betrybe.com </span>,
              por favor! 😉
            </p>
          </div>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default Approval;
